import React from "react";
import useAuth from "../../routes/login/AuthContext";
import { Checkbox } from "../../UI/Checkbox";
import { TableCell } from "../../UI/TableCell";
import { TableHead } from "../../UI/TableHead";
import { TableRow } from "../../UI/TableRow";
import { EnhancedTable } from "../EnhancedTable";
import { EnhancedTableBody } from "../EnhancedTableBody";
import { ReadOnlyWrapper } from "../ReadOnlyWrapper";

const TITLE_TOOLTIP_CONTENT =
  "This is an automatic email sent to all residents who are in your network, regardless of match status, to remind them that the network is going to close. The number of days indicated is the number of days prior to your network close date. You can choose to send none, some, or all of these reminders by checking or unchecking boxes.";

interface IProps {
  data: Record<string, any>;
  setData: any;
  updateNotificationDate: any;
  isDisabled?: boolean;
}

interface IRow {
  closingDate: string;
  is1: boolean;
  is3: boolean;
  is5: boolean;
  is10: boolean;
  l2Name: string;
  set: boolean;
  update: boolean;
}

const tooltipUrl = {
  link: "/static/pdf/network_closing_reminder.pdf",
  text: "View an example of this email communication"
};

export const ConfirmationNotificationTable: React.FC<IProps> = (props) => {
  const { isSuperAdminRead } = useAuth();
  const rows = props.data.notificationDays[0].set ? props.data.notificationDays : [];

  const handleCheckboxToggle = (cell: "5" | "10" | "3" | "1") => () =>
    props.setData((prevState: any) => props.updateNotificationDate(cell, prevState));

  return (
    <EnhancedTable title="User Closing Reminder Email" titleHelpTooltip={TITLE_TOOLTIP_CONTENT} urlHelpTooltip={tooltipUrl}>
      <TableHead secondary>
        <TableRow>
          <TableCell>Subnetwork Name</TableCell>
          <TableCell>Closing Date</TableCell>
          <TableCell>10 Days</TableCell>
          <TableCell>5 Days</TableCell>
          <TableCell>3 Days</TableCell>
          <TableCell>1 Days</TableCell>
        </TableRow>
      </TableHead>
      <EnhancedTableBody colSpan={6}>
        {rows.map((row: IRow) => (
          <TableRow key={row.l2Name}>
            <TableCell>{row.l2Name}</TableCell>
            <TableCell>{row.closingDate}</TableCell>
            <TableCell>
              <ReadOnlyWrapper>
                <Checkbox isDisabled={isSuperAdminRead() || props.isDisabled} name="is10" isChecked={row.is10} onChange={handleCheckboxToggle("10")} disabled={props.isDisabled}/>
              </ReadOnlyWrapper>
            </TableCell>
            <TableCell>
              <ReadOnlyWrapper>
                <Checkbox isDisabled={isSuperAdminRead() || props.isDisabled} name="is5" isChecked={row.is5} onChange={handleCheckboxToggle("5")} disabled={props.isDisabled}/>
              </ReadOnlyWrapper>
            </TableCell>
            <TableCell>
              <ReadOnlyWrapper>
                <Checkbox isDisabled={isSuperAdminRead() || props.isDisabled} name="is3" isChecked={row.is3} onChange={handleCheckboxToggle("3")} disabled={props.isDisabled}/>
              </ReadOnlyWrapper>
            </TableCell>
            <TableCell>
              <ReadOnlyWrapper>
                <Checkbox isDisabled={isSuperAdminRead() || props.isDisabled} name="is1" isChecked={row.is1} onChange={handleCheckboxToggle("1")} disabled={props.isDisabled}/>
              </ReadOnlyWrapper>
            </TableCell>
          </TableRow>
        ))}
      </EnhancedTableBody>
    </EnhancedTable>
  );
};
